/*
  Setas do carrossel "Coleções por ritual".
  Delegacao de evento no document p/ funcionar com multiplas instancias e
  sobreviver ao re-render de sections no editor do tema.
*/
(function () {
  if (window.__chgArrowsBound) return;
  window.__chgArrowsBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.chg-arrow');
    if (!btn) return;
    var wrap = btn.closest('.chg-carousel-wrap');
    var track = wrap && wrap.querySelector('.chg-track');
    if (!track) return;
    var dir = btn.classList.contains('chg-arrow--next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });
})();
